/**
 * @fileoverview Agent definition for the chapter-extractor-v2 primitive.
 *
 * This agent scans a document to identify chapter structures and key sentences.
 *
 * @category import.story.extraction
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas/agent';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'chapter-extractor-v2',
  kind: 'primitive',
  name: 'Chapter Extractor',
  description: 'Scans a document to identify chapter structures and key sentences.',
  category: 'import',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2024-06',
    lastUpdated: '2025-01',
    taxonomyPath: 'import.story.extraction',
    usedBy: ['ImportStoryDialog', 'use-import-story.ts'],
    relatedAgents: ['story-dna-extractor-v2', 'plot-extractor-v2'],
  },
};
